import React from "react";
import formatNumber, { convertNumberToWordsInFCFA, formatDateWithTime, getOrderLineWarehouseCode } from "../utils/functions";
import { APP_NAME } from "../utils";

export default function FactureProFormatComponent({ data }) {
  // Les données principales sont dans data.data selon ton exemple
  const facture = data || {};
  const customer = facture?.customer ? JSON.parse(facture.customer) : {};

  return (
    <div className={`invoice-copy relative`}>
      <div className="flex flex-row justify-between items-start mt-10">
        <div>
          <img src="/assets/img/logo.png" height={100} width={100} alt={APP_NAME} />

          <p className="mt-3 font-medium text-sm tracking-widest">
            ASEBAT SARL
          </p>
          <p className="font-medium text-sm">C/1775 C, QUARTIER GBEDJEKOME - OUEDO</p>
          <p className="font-medium text-sm">BP 952  ABOMEY - CALAVI,BENIN</p>
          <p className="font-medium text-sm">IFU 3202434985932 - RCCMRB/ABC/24 B 7993</p>
          <p className="font-medium text-sm">+229 01 61 89 89 00</p>
        </div>
          <p className="font-medium text-2xl py-3">
            <span className="font-bold uppercase">Facture Proformat</span>
          </p>
      </div>

      <div className="flex flex-row justify-between items-start mt-2">
        <div>
          <p className="font-medium text-xl">
            <span className="font-bold">Référence :</span> <span className="font-bold">{facture.reference}</span>
          </p>
          <p className="font-medium text-sm">
            <span className="font-semibold">Code et Nom Agent</span> : {facture.agent_code || "N/A"} - {facture.agent_nom || "Non spécifié"}
          </p>
          <p className="font-medium text-sm">
            <span className="font-semibold">Date :</span> {formatDateWithTime(new Date(facture.created_at))}
          </p>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="border-collapse mt-3 w-full text-sm whitespace-pre table-auto">
          <thead>
            <tr>
              <th className="p-2 border font-semibold pe-7">Code client</th>
              <th className="p-2 border font-semibold text-start">Client</th>
              <th className="p-2 border font-semibold">IFU</th>
              <th className="p-2 border font-semibold">Téléphone</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="p-2 border font-medium">{customer.code || "N/A"}</td>
              <td className="p-2 border font-medium">{customer.name || "N/A"}</td>
              <td className="p-2 border font-medium">{customer.ifu || "N/A"}</td>
              <td className="p-2 border font-medium">{customer.phone || "N/A"}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="overflow-x-auto">
        <table className="border-collapse w-full text-sm whitespace-pre table-auto">
          <thead>
            <tr>
              <th className="p-2 border font-semibold text-sm">Magasin</th>
              <th className="p-2 border font-semibold text-sm">Produit</th>
              <th className="p-2 border font-semibold text-sm">Prix Unitaire</th>
              <th className="p-2 border font-semibold text-sm pe-7">Quantité</th>
              <th className="p-2 border font-semibold text-sm">Prix Total</th>
            </tr>
          </thead>
          <tbody>
            {facture.produits_json?.length > 0 ? (
              facture.produits_json.map((item, index) => (
                <tr key={index}>
                  <td className="p-2 border font-medium text-sm">
                    {getOrderLineWarehouseCode({
                      magasin_code: item.code_magasin,
                      magasin_label: item.code_magasin,
                    })}
                  </td>
                  <td className="p-2 border font-medium text-sm">{item.nom_produit}</td>
                  <td className="p-2 border font-medium text-sm">{formatNumber(item.prix_unitaire)} FCFA</td>
                  <td className="p-2 border font-medium text-sm">
                    {item.quantite}{" "}
                    {item.unite === "Mettre carré" ? "m²" : item.unite === "Pièce" ? "pc" : item.unite}
                  </td>
                  <td className="p-2 border font-medium text-sm">{formatNumber(item.prix_total)} FCFA</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="p-2 font-medium text-center text-sm">
                  Aucun produit dans le panier.
                </td>
              </tr>
            )}
            <tr>
              <td colSpan={4} className="p-2 border font-semibold text-sm">
                Commentaires
              </td>
              <td colSpan={1} className="p-2 border font-semibold text-end text-sm">
                <b>Total :</b> {formatNumber(Number(facture.montant_net) + Number(facture.remise || 0))} FCFA
              </td>
            </tr>
            <tr>
              <td
                colSpan={4}
                rowSpan={4}
                className="border-e-0 p-2 border font-medium text-sm"
              >
                Les marchandises vendues ne sont ni reprises ni échangées. <br />La disponibilité de votre achat n'est plus garantie 14 jours <br />après la date de facturation.
              </td>
              <td className="p-2 border font-semibold text-end text-sm">
                <b>Montant HT :</b> {formatNumber(facture.montant_ht)} FCFA
              </td>
            </tr>
            {facture.tva > 0 && (
              <tr>
                <td colSpan={1} className="p-2 border font-semibold text-end text-sm">
                  <b>T.V.A (18%) :</b> {formatNumber(facture.tva)} FCFA
                </td>
              </tr>
            )}
            {facture.laib_pourcentage !== null && (
              <tr>
                <td colSpan={1} className="p-2 border font-semibold text-end text-sm">
                  <b>AIB (0{facture.laib_pourcentage}%) :</b> {formatNumber(facture.laib)} FCFA
                </td>
              </tr>
            )}
            {Number(facture.remise) > 0 && (
              <tr>
                <td colSpan={1} className="p-2 border font-semibold text-end text-sm">
                  <b>
                    Remise
                    {Number(facture.remise_pourcentage) > 0 ? ` (${facture.remise_pourcentage}%)` : ''}
                    {' :'}
                  </b>{' '}
                  −{formatNumber(facture.remise)} FCFA
                </td>
              </tr>
            )}
            <tr>
              <td colSpan={1} className="p-2 border font-semibold text-end text-sm">
                <b>NET :</b> {formatNumber(facture.montant_net)} FCFA
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="flex flex-wrap justify-between items-center gap-6 mt-3">
        <div>
          <p className="font-medium text-sm capitalize">
            <span className="font-bold">Montant en lettre</span> : {convertNumberToWordsInFCFA(Math.round(facture.montant_net))}
          </p>
        </div>
      </div>
    </div>
  );
}
